import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import * as $ from 'jquery';
import { LocalstorageService } from 'src/app/core/services/localstorage.service';
import { SalePointsService, SignalModalEmitterService } from 'src/app/core/services/sale-points/sale-points.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { SalePoint } from 'src/app/interfaces/salePoints.interface';
import { User } from 'src/app/interfaces/user.interface';

@Component({
  selector: 'app-address-main',
  templateUrl: './address-main.component.html',
  styleUrls: ['./address-main.component.scss'],
})
export class AddressMainComponent implements OnInit {
  /**Saved user information */
  salePoints: SalePoint[];
  pointGPS: { lat: number; lng: number } | null = null;
  coverage: boolean;
  address: any;
  salePoint: SalePoint;
  user: User;
  public mapsReady = false;

  private readonly isBrowser: boolean;
  constructor(
    private salePointsService: SalePointsService,
    private userService: UserService,
    private localStorage: LocalstorageService,
    @Inject(PLATFORM_ID) private platFormId
  ) {
    this.isBrowser = isPlatformBrowser(this.platFormId);

    SignalModalEmitterService.onChange.subscribe({
      next: (event: string) => {
        this.openModal(event);
      }
    })
  }
  private isGoogleReady(): boolean {
    if (!this.isBrowser) return false;
    return !!(window as any)?.google?.maps && !!(window as any)?.google?.maps?.Map;
  }

  private waitForGoogleMaps(): void {
    if (!this.isBrowser) return;

    const interval = setInterval(() => {
      if (this.isGoogleReady()) {
        clearInterval(interval);
        this.mapsReady = true;
      }
    }, 100);
  }

  ngOnInit(): void {
    this.getSalePoints();
    this.waitForGoogleMaps();

    if (!this.isBrowser) return;

    const raw = this.localStorage.getItem('userLogged');
    const userLogged = raw ? JSON.parse(raw) : null;

    if (userLogged) {
      this.userService.getUserIdLogged().subscribe((userId) => {
        if (userId) {
          this.getUserInfo(userId);
        }
      });
    }
  }

  /**
   * Get user information
   * @param userId User id
   */
  getUserInfo(userId: string): void {
    this.userService.getUserbyId(userId).toPromise().then((doc: any) => {
      this.user = doc as User;
    });
  }

  /**
   *Get sale point information
   */
  async getSalePoints() {
    this.salePointsService.getAllSalePoints().subscribe((res: SalePoint[]) => {
      this.salePoints = res
        .filter(sp => sp.bodega && sp.zonaCobertura && sp.lat && sp.lng && sp.tpv);
    });
  }

  /**
   * Event which receives geolocation information
   * @param event Return the geolocation data
   */
  getGeolocationData(event) {
    this.coverage = event.coverage;
    this.pointGPS = event.pointGPS ? { lat: event.pointGPS.lat, lng: event.pointGPS.lng } : null;
    this.address = event.address;
  }

  /**
   * Event which receives addres information.
   * @param event Return the address data
   */
  getSalePointData(event) {
    this.coverage = event.coverage;
    this.pointGPS = event.pointGPS ? { lat: event.pointGPS.lat, lng: event.pointGPS.lng } : null;
    this.salePoint = event.salePointInfo;
  }

  /**
   * Opens the specified modal on the event
   * @param event Return the modal to open
   */
  openModal(event) {
    if (!this.isBrowser) return;
    $(event)?.click();
  }
}
